var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElement2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 8.33341H5.83317C7.49984 8.33341 8.33317 7.50008 8.33317 5.83341V4.16675C8.33317 2.50008 7.49984 1.66675 5.83317 1.66675H4.1665C2.49984 1.66675 1.6665 2.50008 1.6665 4.16675V5.83341C1.6665 7.50008 2.49984 8.33341 4.1665 8.33341Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 8.33341H15.8332C17.4998 8.33341 18.3332 7.50008 18.3332 5.83341V4.16675C18.3332 2.50008 17.4998 1.66675 15.8332 1.66675H14.1665C12.4998 1.66675 11.6665 2.50008 11.6665 4.16675V5.83341C11.6665 7.50008 12.4998 8.33341 14.1665 8.33341Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 18.3334H15.8332C17.4998 18.3334 18.3332 17.5001 18.3332 15.8334V14.1667C18.3332 12.5001 17.4998 11.6667 15.8332 11.6667H14.1665C12.4998 11.6667 11.6665 12.5001 11.6665 14.1667V15.8334C11.6665 17.5001 12.4998 18.3334 14.1665 18.3334Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 18.3334H5.83317C7.49984 18.3334 8.33317 17.5001 8.33317 15.8334V14.1667C8.33317 12.5001 7.49984 11.6667 5.83317 11.6667H4.1665C2.49984 11.6667 1.6665 12.5001 1.6665 14.1667V15.8334C1.6665 17.5001 2.49984 18.3334 4.1665 18.3334Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElement2);
export default __webpack_public_path__ + "static/media/element2.b8e0080c0f9a0254b898da9f8ff6369c.svg";
export { ForwardRef as ReactComponent };